import React from 'react';
import { Button } from 'rebass/styled-components';
import { faSend } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cs from 'classnames';
import { Field, Form, Formik, FormikHelpers } from 'formik';

import { Box, Flex } from 'shared/components/display';
import TextareaInput from 'shared/components/TextareaInput/TextareaInput';

import { BUTTON_VARIANTS } from 'shared/styles/button';

import { ModuleRevisionValues } from './config';
import styles from './styles';

interface Props {
  editing?: boolean;
  onSubmit: (values: ModuleRevisionValues, formikHelpers: FormikHelpers<ModuleRevisionValues>) => void;
  comment?: string;
}
const ModuleRevisionForm: React.FC<Props> = ({ editing, onSubmit, comment = '' }) => {
  return (
    <Box css={styles} className={cs('module-revision-form')}>
      <Formik<ModuleRevisionValues> onSubmit={onSubmit} initialValues={{ comment }}>
        {(formikHelpers) => (
          <Form>
            <Flex className="module-revision-form__input-border">
              <Field
                name="comment"
                className="module-revision-form__input"
                dataCy="module-revision-form__input"
                component={TextareaInput}
                rows={3}
                maxLength={255}
                softMaxLength={255}
                noMargin
                showCharactersCounter
              />
              <Button
                type="submit"
                variant={BUTTON_VARIANTS.TEXT_ONLY}
                disabled={!formikHelpers.dirty || formikHelpers.isSubmitting}
                className="module-revision-form__send-btn"
                data-cy="module-revision-form__send-btn"
              >
                <FontAwesomeIcon icon={faSend} />
              </Button>
            </Flex>
          </Form>
        )}
      </Formik>
    </Box>
  );
};
export default ModuleRevisionForm;
